'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'lib/utils';
import { typographyVariants } from 'components/ui/typography';

// Form labels follow the eyebrow/label typography variant — mono uppercase, 11px,
// 0.14em tracking. The peer-disabled hooks remain so they coordinate with inputs.
const labelVariants = cva(
  cn(
    typographyVariants({ variant: 'label' }),
    'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  ),
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
